import { env } from '@/config/env';
import { type VehicleListing } from '@/services/vehicles/types';

import { vehiclePath, vehicleTitle } from './vehicleFormat';

/** §28: the WhatsApp message carries the car the visitor is looking at. */
export function vehicleEnquiryMessage(
  v: Pick<VehicleListing, 'make' | 'model' | 'year' | 'stockNo' | 'slug'>,
): string {
  const link = env.siteUrl ? ` ${env.siteUrl}${vehiclePath(v)}` : '';
  return (
    `Hello Kabex Motors, I'm interested in the ${vehicleTitle(v)} listed on your website ` +
    `(stock no. ${v.stockNo}). Please send me the full quotation and import details.${link}`
  );
}
